import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import tags from './tags'
import permission from './permission'
import * as api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    counter: 0,
    sidebar: true,
    type: [],
    level: 0,
    userId: '',
    realName: '',
    authorData: {},
    roleData: {},
    proData: {},
    clientData: {},
    applyData: {},
    invoiceData: {},
    vendorData: {},
    purData: {},
    adPurData: {},
    hrPurData: {},
    payData: {},
    adPayData: {},
    hrPayData: {},
    adData: {},
    hrData: {},
    expenseData: {},
    expensePersonData: {},
    holidayData: {},
    vacationData: {},
    stationeryData: {},
    assetData: {},
    pubcaseData: {},
    simData: {},
    mineholiday: {},
    authorType: '',
    menuLimtList: [],
  },
  getters: {
    doubleCounter(state) {
      return state.counter * 2
    },
    roles: state => state.user.roles,
    hasRoles: state => state.user.roles && state.user.roles.length > 0,
    permission_routes: state => state.permission.routes
  },
  mutations: {
    add(state) {
      state.counter++
    // this.state
    },
    setSidebar(state, flag) {
      state.sidebar = flag
    },
    setType(state, type) {
      state.type = type
    },
    setLevel(state, level) {
      state.level = level
    },
    setName(state, realname) {
      state.realName = realname
    },
    setUserId(state, userId) {
      state.userId = userId
    },
    setProData(state, proData) {
      state.proData = proData
    },
    setAuthorData(state, authorData) {
      state.authorData = authorData
    },
    setRoleData(state, roleData) {
      state.roleData = roleData
    },
    setClientData(state, clientData) {
      state.clientData = clientData
    },
    setApplyData(state, applyData) {
      state.applyData = applyData
    },
    setInvoiceData(state, invoiceData) {
      state.invoiceData = invoiceData
    },
    setVendorData(state, vendorData) {
      state.vendorData = vendorData
    },
    setPurData(state, purData) {
      state.purData = purData
    },
    setAdPurData(state, adPurData) {
      state.adPurData = adPurData
    },
    setHrPurData(state, hrPurData) {
      state.hrPurData = hrPurData
    },
    setPayData(state, payData) {
      state.payData = payData
    },
    setAdPayData(state, adPayData) {
      state.adPayData = adPayData
    },
    setHrPayData(state, hrPayData) {
      state.hrPayData = hrPayData
    },
    setAdData(state, adData) {
      state.adData = adData
    },
    setHrData(state, hrData) {
      state.hrData = hrData
    },
    setExpenseData(state, expenseData) {
      state.expenseData = expenseData
    },
    setExpensePersonData(state, expensePersonData) {
      state.expensePersonData = expensePersonData
    },
    setHolidayData(state, holidayData) {
      state.holidayData = holidayData
    },
    setVacationData(state, vacationData) {
      state.vacationData = vacationData
    },
    setStationeryData(state, stationeryData) {
      state.stationeryData = stationeryData
    },
    setAssetData(state, assetData) {
      state.assetData = assetData
    },
    setPubcaseData(state, pubcaseData) {
      state.pubcaseData = pubcaseData
    },
    setSimData(state, simData) {
      state.simData = simData
    },
    setMineHolidyData(state, mineholiday) {
      state.mineholiday = mineholiday
    },
    setAuthorType(state, authorType) {
      state.authorType = authorType
    },
    setMenuLimtList(state, menuLimtList) {
      state.menuLimtList = menuLimtList
    },
  },
  actions: {
    add({ commit }) {
      setTimeout(() => {
        commit('add')
      }, 1000)
    },
    actType({ commit }) {
      return api
        .getFunctionList({
          type: 2
        })
        .then((res) => {
          const list = (pid) => res.filter((item) => item.pid === pid)

          const options = list('0').map((item) => ({
            value: item.id,
            label: item.title,
            children: list(item.id).map((n) => ({
              value: n.id,
              label: n.title,
              children: list(n.id).length
                ? list(n.id).map((m) => ({
                  value: m.id,
                  label: m.title
                }))
                : undefined
            }))
          }))
          commit('setType', options)
          return options
        })
    }
  },
  modules: {
    tags,
    user,
  permission}
})
